// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ceabce5d","732":"b93ccf10","977":"bbe69cad"}[chunkId] + ".chunk.js";
};